import React from 'react';
import type { Piece as PieceType } from '@/types';
import styles from './Piece.module.css';

interface PieceProps {
  piece: PieceType;
}

const pieceUnicode: Record<string, string> = {
  'white-king': '♔',
  'white-queen': '♕',
  'white-rook': '♖',
  'white-bishop': '♗',
  'white-knight': '♘',
  'white-pawn': '♙',
  'black-king': '♚',
  'black-queen': '♛',
  'black-rook': '♜',
  'black-bishop': '♝',
  'black-knight': '♞',
  'black-pawn': '♟',
};

export const Piece: React.FC<PieceProps> = ({ piece }) => {
  const pieceKey = `${piece.color}-${piece.type}`;
  const unicode = pieceUnicode[pieceKey];
  
  return (
    <div 
      className={`${styles.piece} ${styles[piece.color]}`}
      data-piece={piece.type}
      data-color={piece.color}
    >
      {unicode}
    </div>
  );
};